/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_Blocked_Chrome_2Inputs */



/**
* | output |
* | --- |
* | "Turn Microphone on." |
*
* @param {Practice_Session_Mic_Blocked_Chrome_2Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_chrome_2 = /** @type {((inputs?: Practice_Session_Mic_Blocked_Chrome_2Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_Chrome_2Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zet Microfoon aan.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activez Micro.")
	return /** @type {LocalizedString} */ ("Turn Microphone on.")
});